import { getAepBadgeState, getAepBadgeId, getAepMissedBadgeIds, getAepPayloadContentType, getAepMissedBadgeIdsPayload } from "../../externalApi/AepApi";
// Expose badging APIs
export class WidgetBadge {
    async getAepBadgeState() {
        return await getAepBadgeState();
    }
    async getAepBadgeId() {
        return await getAepBadgeId();
    }
    async getAepMissedBadgeIds() {
        return await getAepMissedBadgeIds();
    }
    async getAepMissedBadgeIdsPayload() {
        return await getAepMissedBadgeIdsPayload();
    }
    async getAepPayloadContentType() {
        return await getAepPayloadContentType();
    }
}
